import React from 'react'
import Layout from './layout'
import logo from '../logo.png'
const pagenotfound = () => {
  return (
    <Layout>
    <img src={logo} alt="" />
    </Layout>
  )
}

export default pagenotfound